import { ApiBase, Options, MethodInfo } from '../../core/ApiBase';
import { pList, rKiraGenelBilgi, rValue } from '../../models/.catalog';

export default class KiraGenelBilgiApi extends ApiBase<pList, rValue<rKiraGenelBilgi>> {
  constructor(options?: Options) {
    super(
      new MethodInfo({
        MethodUrl: '/KiraGenelBilgi',
      }),
      options
    );
  }
}
